import React from 'react';
import { createPortal } from 'react-dom';

const AlertModal = ({ open, title, message, variant = 'info', showCancel = false, onConfirm, onClose, theme = 'light', language = 'en' }) => {
  // accepts `theme` prop ("dark" | "light") and `language` prop ("en" | "ar") to stay decoupled from app context
  if (!open) return null;

  const bg = theme === 'dark' ? '#0b1220' : '#ffffff';
  const text = theme === 'dark' ? '#f1f5f9' : '#0f172a';
  const border = theme === 'dark' ? '1px solid rgba(255,255,255,0.06)' : '1px solid rgba(0,0,0,0.06)';
  const accent = variant === 'error' ? '#ef4444' : variant === 'success' ? '#10b981' : '#3b82f6';
  
  // Translations
  const translations = {
    en: { cancel: 'Cancel', continue: 'Continue', ok: 'OK' },
    ar: { cancel: 'إلغاء', continue: 'متابعة', ok: 'موافق' }
  };
  
  const t = (key) => translations[language]?.[key] || translations.en[key];

  return createPortal(
    <div data-modal-root="true" style={{ position: 'fixed', inset: 0, zIndex: 99999, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(2,6,23,0.6)', backdropFilter: 'blur(8px)', WebkitBackdropFilter: 'blur(8px)' }}>
      <div style={{ width: 'min(560px, 92%)', borderRadius: 12, background: bg, color: text, border, boxShadow: '0 8px 30px rgba(2,6,23,0.6)', overflow: 'hidden' }}>
        <div style={{ padding: '18px 20px', borderBottom: `1px solid rgba(0,0,0,0.04)`, display: 'flex', gap: 12, alignItems: 'center' }}>
          <div style={{ width: 10, height: 40, background: accent, borderRadius: 4 }} />
          <div style={{ fontWeight: 700, fontSize: 16 }}>{title}</div>
        </div>

        <div style={{ padding: '18px 20px', fontSize: 14, lineHeight: '1.45' }}>
          {typeof message === 'string' ? (<pre style={{ whiteSpace: 'pre-wrap', margin: 0 }}>{message}</pre>) : message}
        </div>

        <div style={{ display: 'flex', justifyContent: showCancel ? 'space-between' : 'flex-end', gap: 12, padding: '12px 16px', borderTop: `1px solid rgba(0,0,0,0.04)` }}>
          {showCancel ? (
            <button onClick={onClose} style={{ padding: '8px 14px', borderRadius: 8, border: '1px solid rgba(0,0,0,0.06)', background: theme === 'dark' ? '#111827' : '#fff', color: text }}>{t('cancel')}</button>
          ) : null}
          <div style={{ marginLeft: 'auto' }}>
            <button onClick={() => { if (onConfirm) onConfirm(); else onClose && onClose(); }} style={{ padding: '8px 14px', borderRadius: 8, border: 'none', background: accent, color: '#fff', fontWeight: 600 }}>{showCancel ? t('continue') : t('ok')}</button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default AlertModal;
